import { render, staticRenderFns } from "./HorarioTabs.vue?vue&type=template&id=2698e8bd&scoped=true"
import script from "./HorarioTabs.vue?vue&type=script&lang=js"
export * from "./HorarioTabs.vue?vue&type=script&lang=js"
import style0 from "./HorarioTabs.vue?vue&type=style&index=0&id=2698e8bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698e8bd",
  null
  
)

export default component.exports